"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var lodash_1 = require("lodash");
var react_1 = __importStar(require("react"));
var react_popper_1 = require("react-popper");
var index_1 = __importDefault(require("../../ClickOutside/index"));
var index_2 = __importStar(require("../../Icon/index"));
var FilterItemBody_1 = __importDefault(require("./FilterItemBody"));
var FilterItem = /** @class */ (function (_super) {
    __extends(FilterItem, _super);
    function FilterItem(props) {
        var _this = _super.call(this, props) || this;
        _this.openDialog = function (e) {
            if (e.nativeEvent.outside && e.nativeEvent.outside === _this.props.id) {
                return;
            }
            _this.setState({
                openDialog: true,
            });
        };
        _this.closeDialog = function () {
            _this.setState({
                openDialog: false,
                filter: "",
            });
        };
        _this.changeFilters = function () {
            _this.props.onChange(_this.props.id, _this.state.selectedValues, _this.props.operator ? _this.props.operator : FilterItem.defaultOperator);
            _this.closeDialog();
        };
        _this.selectFilter = function (e) {
            _this.setState({
                filter: e.currentTarget.value,
            });
        };
        _this.renderLabel = function () {
            return null;
        };
        _this.renderDropdownBody = function () {
            return null;
        };
        _this.state = {
            selectedValues: props.selected,
            openDialog: false,
            filter: "",
            withChildren: false,
        };
        return _this;
    }
    FilterItem.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.selected !== this.props.selected) {
            this.setState({ selectedValues: this.props.selected });
        }
    };
    FilterItem.prototype.render = function () {
        var _this = this;
        var _a;
        var _b = this.props, className = _b.className, inTableHeader = _b.inTableHeader, id = _b.id, operator = _b.operator, type = _b.type;
        var _c = this.state, selectedValues = _c.selectedValues, openDialog = _c.openDialog;
        var cn = classnames_1.default("emankit__filter_bar__item", className);
        if (operator && this.validOperators.indexOf(operator) === -1) {
            // tslint:disable-next-line:max-line-length
            throw new Error("Cannot use \"" + operator + "\" operator with filter type \"" + ((_a = type === null || type === void 0 ? void 0 : type.toString()) !== null && _a !== void 0 ? _a : "") + "\". Allowed operators are: \"" + this.validOperators.toString() + "\"");
        }
        var filterLabel;
        if (inTableHeader) {
            var isActive = selectedValues && lodash_1.castArray(selectedValues).length;
            filterLabel = (react_1.default.createElement("span", { className: "rectangle" + (isActive ? " active" : ""), onClick: this.openDialog },
                react_1.default.createElement(index_2.default, { icon: isActive ? index_2.IconType.FilterActive : index_2.IconType.Filter, width: 15, height: 16 })));
        }
        else {
            filterLabel = this.renderLabel();
        }
        /* eslint-disable @typescript-eslint/prefer-as-const */
        return (react_1.default.createElement("div", { className: cn },
            react_1.default.createElement(react_popper_1.Manager, null,
                react_1.default.createElement(react_popper_1.Reference, null, function (_a) {
                    var ref = _a.ref;
                    return react_1.default.createElement("div", { ref: ref }, filterLabel);
                }),
                react_1.default.createElement(index_1.default, { onClickOutside: this.closeDialog, disabled: !openDialog, id: Array.isArray(id) ? id.toString() : id },
                    react_1.default.createElement(react_popper_1.Popper, { placement: "bottom-start", strategy: "fixed", modifiers: [
                            { name: "preventOverflow", enabled: true, options: { rootBoundary: "viewport" } },
                            { name: "offset", enabled: true, options: { offset: [0, 10] } },
                        ] }, function (_a) {
                        var ref = _a.ref, style = _a.style, placement = _a.placement, update = _a.update;
                        return (react_1.default.createElement(FilterItemBody_1.default, { open: openDialog, placement: placement, style: style, innerRef: ref, scheduleUpdate: update }, _this.renderDropdownBody()));
                    })))));
        /* eslint-enable @typescript-eslint/prefer-as-const */
    };
    FilterItem.defaultProps = {
        single: false,
    };
    FilterItem.defaultOperator = "in";
    return FilterItem;
}(react_1.Component));
exports.default = FilterItem;
//# sourceMappingURL=index.js.map